export interface Group {
  id: string,
  memberCount: number,
  postCount: number,
  avatarSrc: string,
  isMember: boolean,
  nameStringId: string,
  groupType: GroupType
}

export enum GroupType {
  Private = 'PRIVATE',
  Restricted = 'RESTRICTED',
}

export interface GetAllGroupsResponse {
  groups: Array<Group>,
}
